import { render, staticRenderFns } from "./emissions01.vue?vue&type=template&id=3cd72a21"
import script from "./emissions01.vue?vue&type=script&lang=js"
export * from "./emissions01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd72a21')) {
      api.createRecord('3cd72a21', component.options)
    } else {
      api.reload('3cd72a21', component.options)
    }
    module.hot.accept("./emissions01.vue?vue&type=template&id=3cd72a21", function () {
      api.rerender('3cd72a21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/emissions01.vue"
export default component.exports